import React, { useState, useEffect } from 'react'
import { Input, Grid, Row, Col, Panel, RadioGroup, Radio, ControlLabel, Message } from 'rsuite'
import { isValidators, requiredFiled, isRequired } from '../../../utils/ValidatorUtils'
import { getValueFromOptions } from '../../../utils/dataUtil'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function WithdrawRequestWithProgressView({ schema: _schema, ...props }) {
  const [schema, setSchema] = useState(_schema)
  const [isProblemEncountered, setIsProblemEncountered] = useState(false)
  const [isRiskEvaluationOfManagement, setIsRiskEvaluationOfManagement] = useState(false)
  const [isRiskEvaluationOfFinace, setIsRiskEvaluationOfFinace] = useState(false)
  const [coordinatorCommentType, setCoordinatorCommentType] = useState(1)

  useEffect(() => {
    if (_schema.isProblemEncountered.value) {
      setIsProblemEncountered(true)
    }

    if (_schema.isRiskEvaluationOfManagement.value) {
      setIsRiskEvaluationOfManagement(true)
    }

    if (_schema.isRiskEvaluationOfFinace.value) {
      setIsRiskEvaluationOfFinace(true)
    }

    if (_schema.coordinatorCommentType.value) {
      setCoordinatorCommentType(_schema.coordinatorCommentType.value)
    }
  }, [_schema])

  return (
    <Panel>
      <Grid fluid>
        {/* ปัญหาและอุปสรรค */}
        <div>
          <p>{schema.titleOfProblemEncountered.label}</p>

          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(
                schema.isProblemEncountered.options,
                schema.isProblemEncountered.value
              ) || 'ไม่มี'}
            </p>

            {isProblemEncountered && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <p>{schema.problemDescription.label}</p>
                <p style={{ textIndent: '2.5em' }}>{schema.problemDescription.value}</p>
              </Row>
            )}
          </Row>
        </div>

        <br />

        {/* การประเมินความเสี่ยง */}
        <div>
          <p>{schema.titleOfRiskEvaluation.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p>{schema.titleOfRiskEvaluationOfManagement.label}</p>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(
                schema.isRiskEvaluationOfManagement.options,
                schema.isRiskEvaluationOfManagement.value
              ) || 'ไม่มี'}
            </p>

            {isRiskEvaluationOfManagement && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <p>{schema.riskEvaluationOfManagementDescription.label}</p>
                <p style={{ textIndent: '2.5em' }}>
                  {schema.riskEvaluationOfManagementDescription.value}
                </p>
              </Row>
            )}
          </Row>

          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p>{schema.titleOfRiskEvaluationOfFinace.label}</p>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(
                schema.isRiskEvaluationOfFinace.options,
                schema.isRiskEvaluationOfFinace.value
              ) || 'ไม่มี'}
            </p>

            {isRiskEvaluationOfFinace && (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                <p>{schema.riskEvaluationOfFinaceDescription.label}</p>
                <p style={{ textIndent: '2.5em' }}>
                  {schema.riskEvaluationOfFinaceDescription.value}
                </p>
              </Row>
            )}
          </Row>
        </div>

        <br />

        {/* ประเมินความน่าสนใจ */}
        <div>
          <p>{schema.titleOfLevelOfInteresting.label}</p>
          <Message
            showIcon
            type="info"
            description={'ในการประชาสัมพันธ์ และเป็นแบบอย่างสำหรับโครงการอื่น'}
          />
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(
                schema.levelOfInteresting.options,
                schema.levelOfInteresting.value
              ) || 'ไม่มี'}
            </p>

            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <p>{schema.interestingDescription.label}</p>
              <p style={{ textIndent: '2.5em' }}>{schema.interestingDescription.value}</p>
            </Row>
          </Row>
        </div>

        <br />

        {/* การใช้จ่ายเงิน */}
        <div>
          <p>{schema.titleOfBudgetRemain.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(schema.isBudgetRemain.options, schema.isBudgetRemain.value) ||
                'ใช้เงินเกิน'}{' '}
              {schema.budgetRemainOrOver.preLabel} {budgetFormat(schema.budgetRemainOrOver.value)}{' '}
              {schema.budgetRemainOrOver.postLabel}
            </p>
          </Row>
        </div>

        <br />

        {/* ความเห็นผู้สนับสนุนและติดตามโครงการ */}
        <div>
          <Row style={{ marginTop: 10, marginLeft: 5 }}>
            <p>{schema.opinionOfCoordinator.label}</p>
            <p style={{ textIndent: '2.5em' }}>{schema.opinionOfCoordinator.value}</p>
          </Row>
        </div>

        <br />

        {/* มีการซื้อครุภัณฑ์ */}
        <div>
          <p>{schema.titleOfBuyingMaterial.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(
                schema.isBuyingMaterial.options,
                schema.isBuyingMaterial.value
              ) || 'ไม่มี'}
              {schema.isBuyingMaterial.value == 2 && `${schema.projectCodeInputMore.value}`}
            </p>
          </Row>
        </div>

        <br />

        {/* ประเมินความก้าวหน้าของโครงการ (อธิบาย) */}
        <div>
          <p>{schema.titleOfProgress.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            <p style={{ textIndent: '2.5em' }}>
              {getValueFromOptions(schema.isProgress.options, schema.isProgress.value) ||
                'ไม่เป็นไปตามแผน / มีการปรับแผน'}
            </p>

            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <p>{schema.progressDescription.label}</p>
              <p style={{ textIndent: '2.5em' }}>{schema.progressDescription.value}</p>
            </Row>
          </Row>
        </div>

        <br />

        {/* ความก้าวหน้าในการดำเนินงานตามแผน เมื่อเทียบกับแผนการดำเนินงานทั้งโครงการ */}
        <div>
          <p>{schema.titleOfPercentOfProgress.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            {/* <p style={{ textIndent: '2.5em' }}>{schema.percentOfProgress.value || 0}</p> */}

            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <span style={{ marginRight: '5px' }}>{schema.percentOfProgress.preLabel}</span>
              <span style={{ marginRight: '5px' }}>{schema.percentOfProgress.value}</span>
              <span style={{ marginRight: '5px' }}>{schema.percentOfProgress.postLabel}</span>
            </Row>
          </Row>
        </div>

        <br />

        {/* ผลผลิตที่เกิดขึ้นจริง (สะสม) เทียบกับผลผลิตทั้งโครงการ */}
        <div>
          <p>{schema.titleOfPercentOfActualOutcome.label}</p>
          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            {/* <p style={{ textIndent: '2.5em' }}>{schema.percentOfActualOutcome.value || 0}</p> */}

            <Row style={{ marginTop: 10, marginLeft: 10 }}>
              <span style={{ marginRight: '5px' }}>{schema.percentOfActualOutcome.preLabel}</span>
              <span style={{ marginRight: '5px' }}>{schema.percentOfActualOutcome.value}</span>
              <span style={{ marginRight: '5px' }}>{schema.percentOfActualOutcome.postLabel}</span>
            </Row>
          </Row>
        </div>

        <br />

        {/* ความเห็นของนักวิชาการสำนัก */}
        <div>
          <p>{schema.titleOfCoordinatorComment.label}</p>

          <Row style={{ marginLeft: 10, marginBottom: 10 }}>
            {coordinatorCommentType == 9 ? (
              <Row style={{ marginTop: 10, marginLeft: 10 }}>
                {/* <p>{schema.otherComment.label}</p> */}
                <p style={{ textIndent: '2.5em' }}>{schema.otherComment.value}</p>
              </Row>
            ) : (
              <p style={{ textIndent: '2.5em' }}>
                {getValueFromOptions(
                  schema.coordinatorCommentType.options,
                  schema.coordinatorCommentType.value
                ) || 'ไม่มี'}
              </p>
            )}
          </Row>
        </div>
      </Grid>
    </Panel>
  )
}
